import React from 'react'
import Routes from './routes/routes'
import Footer from './components/Footer'

import './global.css'
function App() {
  return (
    <>
      <Routes />
      <Footer />
    </>
  )
}

export default App
